<div [formGroup]="parentForm">
  <!-- Custom goal -->
  <div class="grouped fields">
    <div class="field">
      <sui-checkbox formControlName="hasCustomRule">
        Add a custom goal (Max. 74 Characters)
      </sui-checkbox>
    </div>
    <div class="field" *ngIf="parentForm.get('hasCustomRule').value === true">
      <input class="ui input" type="text" placeholder="You must pass the map..."
        [class.error]="hasError('customRule')" formControlName="customRule">
    </div>
  </div>
  <div class="field reward" *ngIf="canChangeReward">
    <label>Reward Amount (Minimum $1, Maximum: $1000)</label>
    <input type="number" name="reward" placeholder="$1"
      formControlName="reward" [class.error]="hasError('reward')">
  </div>
  <div class="field" *ngIf="!bounty">
    <sui-checkbox formControlName="isPool">
      Allow others to add to the reward pool (requires payment
      in advance)
    </sui-checkbox>
    <p *ngIf="parentForm.get('isPool').value === true">
      Creating a bounty with a reward pool requires you to
      pre-pay your reward via paypal.
      This is to guarantee that the winner gets the full reward
      amount that has been contributed.
    </p>
  </div>
</div>
